<template>
  <div>
    <div class="wrapper">
      <MyHeader></MyHeader>
      <div class="content">
        <router-view></router-view>
      </div>
      <!-- <img class="qz" src="../../assets/image/qz3.png" /> -->
    </div>
    <MyFooter class="footer"></MyFooter>
  </div>
</template>
<script>
import MyFooter from "@/components/MyFooter";
import MyHeader from "@/components/MyHeader";
export default {
  name: 'Index',
  components: {
    MyHeader,
    MyFooter
  },
  data () {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  background-image: url("../../assets/image2025/bg.png");
  // background-image: url("../../assets/img/background.jpg");
  background-size: 100% 100%;
  background-repeat: round;
  // background-repeat: no-repeat;
  min-height: 100vh;
  min-width: 1250px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  .qz{
    height: 37%;
    pointer-events: none;
    position: absolute;
    right: 0px;
    bottom: 131px;
    width: 50%;
    min-width: 1000px;
    min-height: 400px;
    // height: auto;
  }
}
.content {
  // min-width: 1280px;
  flex: 1 0 auto;
}
.footer {
  margin-top: auto;
  flex-shrink: 0;
}
</style>
